import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import StaticConfig, { getEnvironment } from "./static-config";
import React from "react";
import Package from "../../package";

// Messages browsers use for a fetch that never got a response
const RAW_NETWORK_ERROR = /^(Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.?|Network request failed)$/;

function isOffline() {
  return typeof navigator !== "undefined" && navigator.onLine === false;
}

// A tab opened before a deploy requests a chunk that no longer exists. Netlify's
// SPA fallback serves index.html in its place, which throws when parsed as JS.
// services/lazy.js reloads the page to recover, so this isn't worth reporting.
function isStaleChunk(error) {
  const [frame] = error.stacktrace || [];
  return (
    error.errorClass === "SyntaxError" &&
    /Unexpected token '?<'?/.test(error.errorMessage) &&
    !!frame &&
    /^https?:\/\/[^/]+\/[^/]+\.js$/.test(frame.file || "") &&
    frame.lineNumber === 1
  );
}

function onError(event) {
  const [error] = event.errors;
  const original = event.originalError;

  if (isStaleChunk(error)) {
    return false;
  }

  const isNetwork =
    (original && original.name === "NetworkError") ||
    (error.errorClass === "TypeError" && RAW_NETWORK_ERROR.test(error.errorMessage));

  if (!isNetwork) {
    return true;
  }

  // Nothing we can do about a device with no connection
  if (isOffline()) {
    return false;
  }

  // Connectivity problems are expected on site; keep them out of the way of real bugs
  // and group by endpoint rather than by whichever page happened to be open
  event.severity = "info";
  if (original && original.url) {
    event.groupingHash = `NetworkError ${original.method} ${original.url}`;
    event.addMetadata("request", {
      method: original.method,
      url: original.url,
    });
  }
  return true;
}

Bugsnag.start({
  redactedKeys: [/access_token/, /id_token/],
  releaseStage: getEnvironment(),
  ...StaticConfig.bugsnag,
  appVersion: Package.version,
  enabledReleaseStages: ["development", "production", "productionJobManager"],
  plugins: [new BugsnagPluginReact(React)],
  onError,
});

export default Bugsnag;
